import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "carAdd"
const CarAddIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.882 7.539C19.039 4.819 17.36 3 15 3H8C5.64 3 3.96 4.82 3.118 7.539a1.75 1.75 0 1 0-.59 3.447C2.51 11.32 2.5 11.657 2.5 12v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1h6v-.8a2 2 0 0 1 2-2h1.2V13a2 2 0 0 1 2-2h1.6c.446 0 .857.146 1.19.392-.005-.136-.01-.271-.018-.406a1.75 1.75 0 1 0-.59-3.447ZM6 15a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm-1-5c0-1 0-5 3.5-5h6C18 5 18 9 18 10H5Z"
          />
          <path d="M22.75 16.2a.25.25 0 0 0-.25-.25h-2.95V13a.25.25 0 0 0-.25-.25h-1.6a.25.25 0 0 0-.25.25v2.95H14.5a.25.25 0 0 0-.25.25v1.6c0 .138.112.25.25.25h2.95V21c0 .138.112.25.25.25h1.6a.25.25 0 0 0 .25-.25v-2.95h2.95a.25.25 0 0 0 .25-.25v-1.6Z" />
        </svg>
      }
    </span>
  )
}
export default CarAddIcon
